module.exports = __webpack_public_path__ + "img/wenduji.b71e1f01.png";